import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=e893e580&scoped=true&"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplate.vue?vue&type=style&index=0&id=e893e580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e893e580",
  null
  
)

export default component.exports